import { ProfessionalProfessions } from '~/constants';
import { getShouldOfficeShowEfda } from '~/growthbook';
import { getAllProfessionTypeOptions } from './DentistUtils';

export const getProfessionNameByCode = (code: string): string => {
  const isShowEFDA = getShouldOfficeShowEfda();

  const professions = getAllProfessionTypeOptions(ProfessionalProfessions, {
    showEfda: isShowEFDA,
  });

  return professions.find((it) => it.code === code)?.name || 'Dental Hygienist';
};
